import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useOrg } from 'src/contexts/OrgContext';
import LoadingBar from '../components/Reusable/LoadingBar';
import { PATH_ROOT } from 'src/routes/paths';

type OrgGuardProps = {
  children: ReactNode;
};

export default function OrgGuard({ children }: OrgGuardProps) {
  const { isInitialized, hasSelectedWorkspace } = useOrg();

  // On a hard reload the org context rehydrates from localStorage
  // ASYNCHRONOUSLY (persistStore.getLocal is a Promise). Until that resolves,
  // selectedOrgId / hasSelectedWorkspace are at their transient empty defaults.
  // Hold on the loader while initializing so we NEVER bounce on the transient
  // empty — only the genuine post-hydration "no workspace ever selected" state
  // (isInitialized && !hasSelectedWorkspace) is allowed to redirect.
  if (!isInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <LoadingBar />
      </Box>
    );
  }

  const shouldBounceToOrgPicker = isInitialized && !hasSelectedWorkspace;
  if (shouldBounceToOrgPicker) {
    return <Navigate to={PATH_ROOT.organization.organizations} replace />;
  }

  return <>{children}</>;
}
